var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Mail = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 1024 832", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M1007.1 195.79a32 32 0 0 0-32.85 1.58L531.92 492.26a32 32 0 0 1-36.94-1L147.2 230.4a32 32 0 1 0-38.4 51.2l347.78 260.83a96.15 96.15 0 0 0 110.85 3.08L960 283.79V736a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h832a32 32 0 0 1 32 32 32 32 0 0 0 64 0 96.11 96.11 0 0 0-96-96H96A96.11 96.11 0 0 0 0 96v640a96.11 96.11 0 0 0 96 96h832a96.11 96.11 0 0 0 96-96V224a32 32 0 0 0-16.9-28.21z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default Mail;
//# sourceMappingURL=Mail.js.map